// @workflow assistant.send-message
/**
 * The two immutable helpers the conversation reducer (events.js) builds every event handler on.
 * No Vue or path-alias imports, so `npm run test:unit` (node --test) can load it directly.
 */

/** Replaces the message with `messageId` by `update(message)`; an unknown id leaves the conversation as it is. */
export function updateMessage(conversation, messageId, update) {
  const index = conversation.messages.findIndex((m) => m.id === messageId);
  if (index < 0) return conversation;
  const messages = conversation.messages.slice();
  messages[index] = update(messages[index]);
  return { ...conversation, messages };
}

/** Replaces the part with `partId`, or appends the one `create` returns. */
export function upsertPart(message, partId, create, update) {
  const index = message.parts.findIndex((p) => p.id === partId);
  const parts = message.parts.slice();
  if (index < 0) parts.push(create());
  else parts[index] = update(parts[index]);
  return { ...message, parts };
}
